import $ from 'jquery';

export default function responsiveIframes() {
    $("iframe[src*='www.youtube.com'], iframe[src*='.vimeo.com']").wrap("<div class='su-iframe-responsive'></div>");
}
